module.exports = __webpack_public_path__ + "media/images/flags/pk-78797206531d5cd9b88c76e99a604db9.svg";